import { compareWithAppVersion } from '@croquiscom/web2app';

import { useZigzag } from '@common/device-manager';
import { gotoShopCategory, ShopCategoryList, useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

import { useCategoryUBL } from '../log/useCategoryUBL';

export const useCategory = () => {
  const is_app = useZigzag();
  const params = useCatalogProductIdParams();

  const { shop, brand_home } = usePdpBaseInfo(params);
  const { clickCategoryItem } = useCategoryUBL();

  const categories = brand_home?.shop_category_list ?? shop.shop_category_list;

  const is_hide = !(is_app && compareWithAppVersion('6.69.0')) || !categories || categories?.length === 0;

  const onClickCategoryItem = (category: ShopCategoryList) => {
    clickCategoryItem(category.id);
    gotoShopCategory({
      shop_id: shop.id,
      display_category_id: category.id,
      title: `${shop.name} / ${category.name}`,
      store_home_deep_link: category.store_home_deep_link,
      zz_origin: 'product_detail',
    });
  };
  return { is_hide, categories, onClickCategoryItem };
};
